module.exports = __webpack_public_path__ + "img/med-cross.082444d8.svg";